import { createContext } from "react";
import { IPlayerPageContext } from "./models/IPlayerPageContext.ts";

export const PlayerPageContext = createContext<IPlayerPageContext>({
    hlsQualityLevels: [],
    handleClickNextEpgItem: () => { },
    handleClickPreviousEpgItem: () => { },
    setIsEpgDetailsModalOpen: () => { },
    isEpgDetailsModalOpen: false,
    setHlsQualityLevels: () => { },
    handleTouchMove: () => { },
    setMenuVisible: () => { },
    toggleFullscreen: async () => { }
})